import { Grid } from '@material-ui/core';
import { Loader } from 'components/Loader';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootStore } from 'redux/store';
import { getAwardsForUserForTeam } from 'redux/thunks';
import { PostsList } from '../PostsList';

const MyTokens: React.FC = () => {
	const dispatch = useDispatch();
	const [filteredAwards, setFilteredAwards] = useState([]);
	const userState = useSelector((store: RootStore) => store.user);

	useEffect(() => {
		if (userState.selectedTeam) {
			dispatch(getAwardsForUserForTeam(userState.selectedTeam?.teamId, userState.userId));
		}
	}, [userState.selectedTeam, userState.userId, dispatch]);

	useEffect(() => {
		if (!userState.awardsLoading) {
			setFilteredAwards(userState.userAwards);
		}
	}, [userState.userAwards, userState.awardsLoading]);


	return (
		<>
			<Grid container direction='column' alignContent='center' alignItems='center'>
				{userState.awardsLoading ? (
					<div className='loader-wrapper'>
						<Loader />
					</div>
				) : filteredAwards.length > 0 ? (
					<PostsList
						condensedPosts={true}
						postsProp={filteredAwards}
						userId={userState.userId}
						subpostsLoading={userState.awardsLoading}
						currentTeam={userState.selectedTeam}
					/>
				) : (
					<div className='no-posts-message'>No tokens have been given to you.</div>
				)}
			</Grid>
		</>
	);
};

export default MyTokens;
